import React from "react";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

//Entry in Bvo


// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import QuestionSlide from "pages/QuestionSec/QuestionSlide";
//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Dashboards from "pages/Dashboard/index1";
// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import EChart from "../pages/Charts/EChart";
// import SparklineChart from "../pages/Charts/SparklineChart";

//Dashboards Chart1

import ChartApex1 from "../pages/Chart1/Apexcharts1"
import EChart1 from "pages/Chart1/EChart1";

// Dashboard chart 2 

import ChartApex2 from "../pages/Chart2/Apexchart2"
import EChart2 from "pages/Chart2/EChart2";





//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesInvoice from "../pages/Utility/PagesInvoice";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesGallery from "../pages/Utility/PagesGallery";
import PagesDirectory from "../pages/Utility/PagesDirectory";
import PagesProfile from "pages/Utility/pages-profile";
import OnBoarding from 'pages/modal/modal';
import AccountantConnect from "pages/AccountatConnect/AccountantConnect";
import IndexBenchMarking from "pages/AllCharts/benchmarking/IndexBenchMarking";
import IndexBenchMarking1 from "pages/AllCharts1/benchmarking1/IndexBenchMarking1";
import IndexBenchMarking2 from "pages/AllCharts2/benchmarking2/IndexBenchMarking2";
import ReportIndex from "pages/reports/ReportIndex";

const userRoutes = [
  { path: "/dashboard/cables-r-us", component: <Dashboard /> },
  { path: "/dashboard/motor-bikes-for-sale", component: <Dashboards /> },


// Account for Connect
{path:"/accountantconnect" , component:<AccountantConnect/>},
  // //profile
  { path: "/profile", component: <UserProfile /> },

//Reports
{path:"/reports",component:<ReportIndex/> },
  // {path:"/Bvo-Ai", component:<BvoAi/>},
  {path:"/adjustments", component:<PagesComingsoon />},

  //Charts
  { path: "/dashboard/motor-bikes-for-sale/apex-charts", component: <ChartApex /> },
  { path: "/dashboard/motor-bikes-for-sale/e-charts", component: <EChart /> },

  //BenchMArking 
  {path:"/industry-benchmarking", component:<IndexBenchMarking/>},
  {path:"/industry-benchmarking1", component:<IndexBenchMarking1/>},
  {path:"/industry-benchmarking2", component:<IndexBenchMarking2/>},

  
  //Dashboards Chart1
  { path: "/dashboard/cables-r-us/apex-chart", component: <ChartApex1 /> },
  { path: "/dashboard/cables-r-us/e-chart", component: <EChart1 /> },

 //Dashboard Chart 2
 {path:"/apex-chart2", component:<ChartApex2/>},
 {path:"/e-chart2" , component:<EChart2/>},



  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },
  { path: "/pages-gallery", component: <PagesGallery /> },
  { path: "/pages-profile", component: <PagesProfile /> },

  // this route should be at the end of all other routes

];

const authRoutes = [

  //onBoarding
  { path: "*", component: <Pages404 /> },
  { path: "/on-boarding", component: < Login/> },
  { path: "/", component: <Login /> },
  { path: "/questions", component: <QuestionSlide /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },


  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },
];

export { userRoutes, authRoutes };
